<template>
  <a-layout>
    <a-layout-content>
      <div
        :class="[$style.layout, backgroundEnabled ? $style.light : '']"
        :style="{backgroundImage: backgroundEnabled ? `url(\'resources/images/photos/${backgroundNumber}.jpeg\')` : 'none'}"
      >
        <div :class="$style.header">
          <div :class="$style.logo">
            <router-link to="/">
              <img
                v-if="!backgroundEnabled"
                src="resources/images/logo.png"
                alt="Nilo Admin"
              >
              <img
                v-if="backgroundEnabled"
                src="resources/images/logo-inverse.png"
                alt="Nilo Admin"
              >
            </router-link>
          </div>
          <div :class="$style.controls">
            <div class="d-inline-block mr-3">
              <a-button type="default" @click="changeBackground">Alterar Fundo</a-button>
            </div>
            <div class="d-inline-block">
              <a-button type="default" @click="toggleBackground">Ligar/Desligar Fundo</a-button>
            </div>
          </div>
          <nav :class="$style.navigation">
            <ul :class="$style.navigationItems">
              <li>
                <a href="javascript: void(0);">&larr; Voltar</a>
              </li>
              <li>
                <a :class="$style.navigationActive" href="javascript: void(0);">Acesso</a>
              </li>
              <li>
                <a href="javascript: void(0);">Sobre</a>
              </li>
              <li>
                <a href="javascript: void(0);">Suporte</a>
              </li>
            </ul>
          </nav>
        </div>
        <div :class="$style.content">
          <router-view/>
        </div>
        <div :class="[$style.footer, 'text-center']">
          <ul class="list-unstyled list-inline mb-3">
            <li class="list-inline-item">
              <a href="javascript: void(0);">Termos de uso</a>
            </li>
            <li class="active list-inline-item">
              <a href="javascript: void(0);">Canal de Denúncias</a>
            </li>
            <li class="list-inline-item">
              <a href="javascript: void(0);">Suporte Técnico</a>
            </li>
            <li class="list-inline-item">
              <a href="javascript: void(0);">Contatos</a>
            </li>
          </ul>
          <p>&copy; 2020 Nilo HealthTech. All rights reserved.</p>
        </div>
      </div>
    </a-layout-content>
  </a-layout>
</template>

<script>
export default {
  name: 'LoginLayout',
  data: function () {
    return {
      backgroundEnabled: false,
      backgroundNumber: 1,
    }
  },
  methods: {
    changeBackground() {
      this.backgroundEnabled = true
      if (this.backgroundNumber === 5) {
        this.backgroundNumber = 1
      } else {
        this.backgroundNumber += 1
      }
    },
    toggleBackground() {
      this.backgroundEnabled = !this.backgroundEnabled
    },
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
